import type { Nullable } from "models-webgl2";
import { Vec2 } from "utils/math/vec2";
import { Webgl2Component } from "../../webgl2-component";
import { getRootParent } from "./global.utils";
import { Mat3 } from "utils/math/mat3";

export class Global {
  public static getRootParent(component: Nullable<Webgl2Component<any, any>>) {
    if (!component) return [];
    return getRootParent(component);
  }

  public static globalMouseToComponentLocal(
    globalMousePos: Vec2,
    component: Webgl2Component<any, any>,
  ): Vec2 {
    const topLeft = this.getComponentClipSpaceInGlobal(component, Vec2.zero());
    return globalMousePos.transformMat3(
      Mat3.identity().rotate(-component.transform.rads).translate(topLeft.clone().negate()).mat,
    );
  }

  public static getComponentClipSpaceInGlobal(
    component: Webgl2Component<any, any>,
    zeroToOne: Vec2,
  ): Vec2 {
    return zeroToOne.transformMat3(component.getModelMatrix());
  }
}

export default Global;
